import { isEmpty } from "lodash-es";
import { IMAGE_FILETYPE, METADATA_FILETYPE } from "../../app.constants";

const IMAGE_MIME_TYPES = [IMAGE_FILETYPE.JPEG, IMAGE_FILETYPE.PNG, IMAGE_FILETYPE.BMP, IMAGE_FILETYPE.TIF, IMAGE_FILETYPE.TIFF];

const IMAGE_FILE_TYPE = new Set<string>(IMAGE_MIME_TYPES);

const MEDIA_MIME_TYPES = [...IMAGE_MIME_TYPES, IMAGE_FILETYPE.AVI, IMAGE_FILETYPE.MP4, IMAGE_FILETYPE.WAV];

const MEDIA_FILE_TYPE = new Set<string>(MEDIA_MIME_TYPES);

export function normalize(value: string): string {
  return (value ?? "").toLowerCase();
}

export function normalizeExtension(extension): string {
  if (isEmpty(extension) || typeof extension !== "string") {
    throw new Error(`Invalid extension: ${extension}`);
  }
  return [extension.startsWith(".") ? "" : ".", extension.toLowerCase()].join("");
}

export function hasExtension(fileName: string, extensions: string[] | Set<string>): boolean {
  const lowerCaseName = normalize(fileName);

  const extensionList = extensions instanceof Set ? Array.from(extensions) : extensions;

  return extensionList.some((extension) => lowerCaseName.endsWith(normalizeExtension(extension)));
}

export const InspectionFileValidator = {
  isValidImageFileType: (type: string, fileName: string) => {
    return IMAGE_FILE_TYPE.has(normalize(type)) || hasExtension(fileName, [IMAGE_FILETYPE.EXTENSION_HEIC, IMAGE_FILETYPE.EXTENSION_HEIF]);
  },
  isValidMediaFileType: (type: string, fileName: string) => {
    return (
      MEDIA_FILE_TYPE.has(normalize(type)) ||
      hasExtension(fileName, [
        IMAGE_FILETYPE.EXTENSION_HEIC,
        IMAGE_FILETYPE.EXTENSION_HEIF,
        IMAGE_FILETYPE.EXTENSION_AVI,
        IMAGE_FILETYPE.EXTENSION_MP4,
        IMAGE_FILETYPE.EXTENSION_WAV,
        IMAGE_FILETYPE.EXTENSION_MSVIDEO,
        IMAGE_FILETYPE.EXTENSION_XMSVIDEO
      ])
    );
  },
  isXMLFile: (type: string) => {
    return type.toLowerCase() === METADATA_FILETYPE.EXTENSION_XML;
  },
  isValidJsonFile: (fileName: string) => {
    return hasExtension(fileName, [IMAGE_FILETYPE.EXTENSION_JSON, IMAGE_FILETYPE.EXTENSION_JSN]);
  },
  isValidInspectionFileType: (type: string, name: string) => {
    const isValidXMLFile = InspectionFileValidator.isXMLFile(type);
    const isValidJSONFile = InspectionFileValidator.isValidJsonFile(name);
    const isValidMediaFile = InspectionFileValidator.isValidMediaFileType(type, name);

    return isValidXMLFile || isValidJSONFile || isValidMediaFile;
  },
  isWavAudioFile(fileName: string): boolean {
    return hasExtension(fileName, [IMAGE_FILETYPE.EXTENSION_WAV]);
  }
};
